import "../css/hero.css";
import hero from "../img/marker888-trans.webp";
import heroImage from "../img/Khon-Kaen-1.webp";
import { useEffect, useState } from "react";
import 'bootstrap-icons/font/bootstrap-icons.css';
import { transformImageUrl, generateSrcset, generateSizes } from '../../utils/imageTransform';
import { Helmet } from 'react-helmet-async';

const Hero = () => {
    const [isVisible, setIsVisible] = useState(false);

    useEffect(() => {
        const heroImg = document.querySelector('.hero-img');
        if (heroImg) heroImg.style.opacity = '1';

        const delay = 130;
        const timeoutId = setTimeout(() => {
            setIsVisible(true);
        }, delay);

        return () => clearTimeout(timeoutId);
    }, []);

    // Get image path for preload - use direct import path for better preload
    const heroImgPath = heroImage.default || heroImage;
    // PRIORITY 3: Optimize LCP image - use smaller size for mobile, higher quality for desktop
    const heroImgSrc = transformImageUrl(heroImgPath, 'width=800,quality=80,format=webp');
    const heroImgSrcset = generateSrcset(heroImgPath, { quality: 80, widths: [400, 800, 1200, 1600] });
    const heroImgSizes = generateSizes({ mobile: '100vw', tablet: '100vw', desktop: '1200px' });
    const markerImgPath = hero.default || hero;

    return (
        <>
            {/* Preload LCP image for faster rendering - Critical for LCP */}
            <Helmet>
                <link rel="preload" as="image" href={heroImgSrc} fetchPriority="high" imagesrcset={heroImgSrcset} imagesizes={heroImgSizes} />
                <link rel="preload" as="image" href={markerImgPath} />
            </Helmet>
            <section className={`hero ${isVisible ? "slide-up active" : "slide-up"}`}>
                {/* Hero Main Section */}
                <div className="position-relative mb-5" style={{ borderRadius: "20px", overflow: "hidden" }}>
                {/* Background Image */}
                <div 
                    className="hero-img position-absolute" 
                    style={{ 
                        top: 0, 
                        left: 0, 
                        right: 0, 
                        bottom: 0, 
                        width: "100%", 
                        height: "100%",
                        zIndex: 0 
                    }}
                >
                    <img
                        src={heroImgSrc}
                        srcSet={heroImgSrcset}
                        sizes={heroImgSizes}
                        alt="Khon Kaen"
                        loading="eager"
                        fetchPriority="high"
                        decoding="async"
                        width="800"
                        height="600"
                        style={{
                            width: "100%",
                            height: "100%",
                            objectFit: "cover",
                            objectPosition: "center",
                            display: "block"
                        }}
                    />
                </div>

                {/* Gradient Overlay */}
                <div 
                    className="position-absolute" 
                    style={{ 
                        top: 0, 
                        left: 0, 
                        right: 0,
                        bottom: 0,
                        width: "100%",
                        height: "100%",
                        background: 'linear-gradient(135deg, rgba(0, 0, 0, 0.85) 0%, rgba(0, 0, 0, 0.65) 50%, rgba(0, 0, 0, 0.85) 100%)',
                        zIndex: 1 
                    }}
                />

                {/* Content */}
                <div className="position-relative row p-5 justify-content-center align-items-center" style={{ zIndex: 2, minHeight: "600px" }}>
                    {/* Left Side - Logo */}
                    <div className="col-12 col-lg-5 mb-4 mb-lg-0 text-center">
                        <div className="hero-img-marker" style={{ maxWidth: "400px", margin: "0 auto" }}>
                            <img 
                                className="people w-100" 
                                src={hero.default || hero}
                                alt="taxi ubr" 
                                loading="eager"
                                fetchpriority="high"
                                decoding="async"
                                width="400"
                                height="400"
                                style={{ 
                                    filter: "drop-shadow(0 10px 30px rgba(0,0,0,0.5))",
                                    maxWidth: "100%",
                                    height: "auto"
                                }}
                            />
                        </div>
                    </div>

                    {/* Right Side - Content */}
                    <div className="col-12 col-lg-7 text-white">
                        <div style={{ maxWidth: "600px" }}>
                            <h1 className="text-white mb-4" style={{ 
                                fontWeight: "800", 
                                fontSize: "clamp(1.8rem, 4vw, 3.2rem)", 
                                letterSpacing: ".05em",
                                lineHeight: "1.2",
                                textShadow: "2px 4px 12px rgba(0,0,0,0.7)"
                            }}>
                                แท็กซี่ขอนแก่นอันดับ 1<br />
                                <span style={{ color: "#fbbf24" }}>บริการเช่ารถพร้อมคนขับ</span>
                            </h1>

                            {/* CTA Button */}
                            <a 
                                href="https://line.me/R/ti/p/@sanookcar"
                                target="_blank"
                                rel="noopener noreferrer"
                                className="btn btn-lg mb-5 d-inline-flex align-items-center gap-2"
                                style={{
                                    backgroundColor: "#fbbf24",
                                    color: "#000",
                                    fontWeight: "700",
                                    fontSize: "1.2rem",
                                    padding: "1rem 2.5rem",
                                    borderRadius: "50px",
                                    border: "none",
                                    boxShadow: "0 8px 20px rgba(251, 191, 36, 0.4)",
                                    transition: "all 0.3s ease",
                                    textDecoration: "none"
                                }}
                                onMouseOver={(e) => {
                                    e.currentTarget.style.transform = "translateY(-2px)";
                                    e.currentTarget.style.boxShadow = "0 12px 28px rgba(251, 191, 36, 0.6)";
                                }}
                                onMouseOut={(e) => {
                                    e.currentTarget.style.transform = "translateY(0)";
                                    e.currentTarget.style.boxShadow = "0 8px 20px rgba(251, 191, 36, 0.4)";
                                }}
                            >
                                <i className="bi bi-line"></i>
                                สอบถามราคา
                            </a>

                            {/* Services */}
                            <div className="mb-4">
                                <h2 className="text-white mb-3" style={{ fontSize: "1.1rem", fontWeight: "600", opacity: 0.9 }}>
                                    ศูนย์แท็กซี่
                                </h2>
                                <ServiceList />
                            </div>

                            {/* Description */}
                            <p style={{ 
                                fontSize: "1rem", 
                                lineHeight: "1.7",
                                textAlign: "justify",
                                opacity: 0.95
                            }}>
                                ให้บริการรับส่งสนามบินจองล่วงหน้า ให้บริการนำเที่ยว แนะนำสถานที่ท่องเที่ยวที่น่าสนใจในขอนแก่น และทั่วประเทศ มีรถให้บริการ รถแท็กซี่รถส่วนบุคคล
                            </p>
                            <p style={{ 
                                fontSize: "1.05rem", 
                                fontStyle: "italic",
                                fontWeight: "500",
                                color: "#fbbf24",
                                marginTop: "1rem"
                            }}>
                                เดินทางไปกับเราสะอาดปลอดภัย มั่นใจทุกเส้นทาง
                            </p>
                        </div>
                    </div>
                </div>
            </div>

            <ContactSection />
        </section>
        </>
    );
};

const ServiceList = () => {
    const services = [
        "บริการรถแท็กซี่",
        "แท็กซี่มิเตอร์",
        "เหมารถแท็กซี่",
        "เหมารถตู้",
        "รับส่งทั่วประเทศ"
    ];

    return (
        <ul className="service-list row row-cols-2 g-2" style={{ listStyle: "none", padding: 0, margin: 0 }}>
            {services.map((service, index) => (
                <li key={index} className="col">
                    <div 
                        className="d-flex align-items-center p-2 h-100"
                        style={{
                            backgroundColor: "rgba(255, 255, 255, 0.1)",
                            borderRadius: "8px",
                            backdropFilter: "blur(10px)",
                            border: "1px solid rgba(255, 255, 255, 0.2)"
                        }}
                    >
                        <span className="me-2" style={{ flexShrink: 0 }}>
                            <ServiceIcon />
                        </span>
                        <span style={{ fontSize: "0.95rem", fontWeight: "500" }}>{service}</span>
                    </div>
                </li>
            ))}
        </ul>
    );
};

const ServiceIcon = () => (
    <svg style={{ color: "#fbbf24" }} width="20" height="20" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor">
        <circle cx="12" cy="12" r="10" fill="#fbbf24" />
        <path d="M9 12l2 2 4-4" stroke="#000" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" fill="none" />
    </svg>
);

const ContactSection = () => {
    return (
        <div className="row justify-content-center">
            <div className="col-12 col-xl-10">
                <div 
                    className="p-4 p-md-5" 
                    style={{
                        background: "linear-gradient(135deg, #1e293b 0%, #0f172a 100%)",
                        borderRadius: "20px",
                        boxShadow: "0 10px 40px rgba(0,0,0,0.3)"
                    }}
                >
                    <h3 className="text-white text-center mb-4" style={{ fontSize: "1.8rem", fontWeight: "700" }}>
                        ติดต่อเราได้ทันที
                    </h3>
                    
                    <div className="row g-3 align-items-center">
                        {/* Owner photo */}
                        <div className="col-12 col-md-4 col-lg-3">
                            <div style={{ 
                                borderRadius: "20px",
                                overflow: "hidden"
                            }}>
                                <img 
                                    src="/owner-profile.webp" 
                                    alt="รูปเจ้าของ TaxiUbr Thailand" 
                                    className="w-100"
                                    loading="lazy"
                                    width="300"
                                    height="300"
                                    style={{ 
                                        width: "100%",
                                        height: "100%",
                                        aspectRatio: "1/1",
                                        objectFit: "cover",
                                        display: "block"
                                    }}
                                />
                            </div>
                        </div>

                        {/* Contact buttons */}
                        <div className="col-12 col-md-8 col-lg-9">
                            <div className="d-flex flex-column gap-3">
                                <LineLink />
                                <WhatsAppLink />
                                <PhoneLink />
                                <FacebookLink />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

const SocialLink = ({ href, backgroundColor, iconPath, text, subText, iconViewBox = "0 0 16 16", iconFill, iconClass }) => (
    <a 
        className="text-decoration-none text-white social-contact-link" 
        href={href} 
        target="_blank" 
        rel="noopener noreferrer"
        style={{ display: "block" }}
    >
        <div 
            className="d-flex gap-3 align-items-center" 
            style={{ 
                borderRadius: "12px", 
                backgroundColor,
                boxShadow: "0 4px 12px rgba(0,0,0,0.15)", 
                transition: "all 0.3s ease",
                cursor: "pointer",
                border: "2px solid transparent"
            }}
            onMouseOver={(e) => {
                e.currentTarget.style.transform = "translateX(8px)";
                e.currentTarget.style.boxShadow = "0 6px 20px rgba(0,0,0,0.25)";
                e.currentTarget.style.borderColor = "rgba(255,255,255,0.3)";
            }}
            onMouseOut={(e) => {
                e.currentTarget.style.transform = "translateX(0)";
                e.currentTarget.style.boxShadow = "0 4px 12px rgba(0,0,0,0.15)";
                e.currentTarget.style.borderColor = "transparent";
            }}
        >
            <div 
                className="d-flex align-items-center justify-content-center" 
                style={{ 
                    backgroundColor: "white", 
                    flexShrink: 0, 
                    borderRadius: "10px",
                    boxShadow: "0 2px 8px rgba(0,0,0,0.1)"
                }}
            >
                {iconClass ? (
                    <i className={iconClass} style={{ color: iconFill || backgroundColor, lineHeight: 1 }}></i>
                ) : (
                    <svg style={{ display: "block" }} viewBox={iconViewBox} fill={iconFill || backgroundColor} xmlns="http://www.w3.org/2000/svg">
                        {iconPath}
                    </svg>
                )}
            </div>
            <div className="text-start flex-grow-1">
                {subText && <div style={{ color: '#ffffff', opacity: 0.95 }}>{subText}</div>}
                <div className="fw-bold" style={{ color: '#ffffff' }}>{text}</div>
            </div>
        </div>
    </a>
);

const PhoneLink = () => (
    <SocialLink 
        href="tel:+66952215764" 
        backgroundColor="#007bff" 
        text="095-221-5764" 
        subText="โทรสายด่วน"
        iconPath={<path d="M1.885.511a1.745 1.745 0 0 1 2.61.163L6.29 2.98c.329.423.445.974.315 1.494l-.547 2.19a.678.678 0 0 0 .178.643l2.457 2.457a.678.678 0 0 0 .644.178l2.189-.547a1.745 1.745 0 0 1 1.494.315l2.306 1.794c.829.645.905 1.87.163 2.611l-1.034 1.034c-.74.74-1.846 1.065-2.877.702a18.634 18.634 0 0 1-7.01-4.42 18.634 18.634 0 0 1-4.42-7.009c-.362-1.03-.037-2.137.703-2.877L1.885.511z"/>}
    />
);

const FacebookLink = () => (
    <SocialLink 
        href="https://www.facebook.com/profile.php?id=61556482434476" 
        backgroundColor="#3b5998" 
        text="Facebook Page" 
        subText="ติดตามเราได้ที่"
        iconPath={<path d="M16 8.049c0-4.446-3.582-8.05-8-8.05C3.58 0-.002 3.603-.002 8.05c0 4.017 2.926 7.347 6.75 7.951v-5.625h-2.03V8.05H6.75V6.275c0-2.017 1.195-3.131 3.022-3.131.876 0 1.791.157 1.791.157v1.98h-1.009c-.993 0-1.303.621-1.303 1.258v1.51h2.218l-.354 2.326H9.25V16c3.824-.604 6.75-3.934 6.75-7.951z"/>}
    />
);

const LineLink = () => (
    <SocialLink 
        href="https://line.me/R/ti/p/@sanookcar" 
        backgroundColor="#00B000" 
        text="เพิ่มเพื่อน" 
        subText="LINE Official Account"
        iconClass="bi bi-line"
        iconFill="#00B000"
    />
);

const WhatsAppLink = () => (
    <SocialLink 
        href="https://wa.me/66952215764" 
        backgroundColor="#128C43" 
        text="095-221-5764" 
        subText="แชทผ่าน WhatsApp"
        iconViewBox="0 0 448 512"
        iconPath={
            <path d="M380.9 97.1C339 55.1 283.2 32 223.9 32c-122.4 0-222 99.6-222 222 0 39.1 10.2 77.3 29.6 111L0 480l117.7-30.9c32.4 17.7 68.9 27 106.1 27h.1c122.3 0 224.1-99.6 224.1-222 0-59.3-25.2-115-67.1-157zm-157 341.6c-33.2 0-65.7-8.9-94-25.7l-6.7-4-69.8 18.3L72 339.2l-4.4-7c-18.5-29.4-28.2-63.3-28.2-98.2 0-101.7 82.8-184.5 184.6-184.5 49.3 0 95.6 19.2 130.4 54.1 34.8 34.9 56 81.2 56 130.5 0 101.8-84.9 184.6-186.6 184.6zm101.2-138.2c-5.5-2.8-32.8-16.2-37.9-18-5.1-1.9-8.8-2.8-12.5 2.8-3.7 5.6-14.3 18-17.6 21.8-3.2 3.7-6.5 4.2-12 1.4-32.6-16.3-54-29.1-75.5-66-5.7-9.8 5.7-9.1 16.3-30.3 1.8-3.7.9-6.9-.5-9.7-1.4-2.8-12.5-30.1-17.1-41.2-4.5-10.8-9.1-9.3-12.5-9.5-3.2-.2-6.9-.2-10.6-.2-3.7 0-9.7 1.4-14.8 6.9-5.1 5.6-19.4 19-19.4 46.3 0 27.3 19.9 53.7 22.6 57.4 2.8 3.7 39.1 59.7 94.8 83.8 35.2 15.2 49 16.5 66.6 13.9 10.7-1.6 32.8-13.4 37.4-26.4 4.6-13 4.6-24.1 3.2-26.4-1.3-2.5-5-3.9-10.5-6.6z"/>
        }
    />
);

export default Hero;